import { Component, OnInit, ViewChild } from '@angular/core';
import {Events, NavParams, Platform, SelectPopoverOption, ViewController} from 'ionic-angular';

import { MeasureContextService } from '../../../app/core/measure-context.service';
import { PKLocalService } from '../../../app/core/local-data-services/pk-local.service';
import { PK, Observation, ObservationType, Potential, Way } from '../../../app/models/models';
import {MyApp} from "../../../app/app.component";
import {ThemeProvider} from "../../../providers/theme/theme";
import {NgSelectOption} from "@angular/forms";

@Component({
  selector: 'page-observation-modal',
  templateUrl: 'observation-modal.html'
})
export class ObservationModalPage implements OnInit {
  observation: Observation;
  observationTypes: ObservationType[];
  impossible: boolean;
  pk: PK;
  potential: Potential;
  way: Way;
  theme: string;
  selectOptions;
  @ViewChild("f") form;

  constructor(private measureContextService: MeasureContextService,
              private navParams: NavParams,
              private viewCtrl: ViewController,
              public themeProvider: ThemeProvider) {

    this.selectOptions = {
      mode: 'md',
      cssClass: this.themeProvider.applicationTheme
    }
  }

  ngOnInit() {
    this.impossible = this.navParams.get('impossible') || false;
    this.observation = Object.assign(new Observation(), this.navParams.get('observation'));
    this.pk = PKLocalService.getCurrentPk();
    this.potential = new Potential(this.pk.potential);
    this.way = new Way(this.pk.way);
    this.observationTypes = JSON.parse(localStorage.getItem('observationTypes'));
  }

  cancel() {
    this.viewCtrl.dismiss(null, 'cancel');
  }

  compareObservation(o1: Observation, o2: Observation): boolean {
    return o1 && o2 && o1.id === o2.id;
  }

  confirm() {
    let role: string = 'confirm';
    if (this.impossible) {
      this.measureContextService.register();
      role = 'confirm-impossible';
    }
    this.viewCtrl.dismiss(this.observation, role);
  }

  delete() {
    this.viewCtrl.dismiss(null, 'delete');
  }
}



// WEBPACK FOOTER //
// ./src/pages/measure-input/observation-modal/observation-modal.ts